import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useLocalStorage from "../utils/useLocalStorage";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const LangSwitcher = () => {

  const { t, i18n } = useTranslation();
  const [lang, setLang] = useLocalStorage("langiage.setting", i18n.language);

  const supportedLangs = i18n.languages;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="languageswitcher-button"
        aria-controls={open ? 'languageswitcher-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        style={{backgroundColor: '#7ac143'}}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {t('language.'+lang)}
      </Button>
      <Menu 
        id="languageswitcher-menu"
        MenuListProps={{
          'aria-labelledby': 'languageswitcher-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {supportedLangs.map(
        (code) => (
          <MenuItem onClick={() => i18n.changeLanguage(code).then(() => setLang(i18n.language))}>
            {t('language.'+code)}
          </MenuItem>
        ),
      )}
      </Menu>
    </div>
  );
}

export default LangSwitcher;


